import React from 'react';

import { Container, Inner } from './styles';

type NavBarAlign = 'left' | 'right' | 'space-between' | 'center';

interface NavBarProps {
    align?: NavBarAlign;
    fullwidth?: boolean;
    isSearchBar?: boolean;
    insideStories?: boolean;
    isNewMainScreen?: boolean;
    children?: React.ReactNode;
}

export const NavBar: React.FC<NavBarProps> = (props) => {
    return (
        <Container fullwidth={props.fullwidth} isNewMainScreen={props.isNewMainScreen} insideStories={props.insideStories}>
            <Inner
                align={props.align}
                fullwidth={props.fullwidth}
                isSearchBar={props.isSearchBar}
                insideStories={props.insideStories}
                isNewMainScreen={props.isNewMainScreen}
            >
                {props.children}
            </Inner>
        </Container>
    );
};
